import { Helper } from '@/services/helper/helper';

/**
 * Helper for specific functions to communicate with AdService 2.
 */
class AdServiceHelper {
	static CONNECTOR_VERSION = 16;

	/**
	 * Pushes function or slot name to be queued and called when AdService 2 is available.
	 * @param {string|function} func - The slot name or function to be called.
	 */
	static servicePush (func) {
		window.AdService.push(func);
	}

	/**
	 * Listens to an AdService 2 event and calls function when event is fired.
	 * @param {string} eventName - The event name to listen to.
	 * @param {function} func - The function to be called when event is fired.
	 * @see {@link AdServiceHelper.servicePush}
	 */
	static listenEvent (eventName, func) {
		this.servicePush(() => {
			window.AdService.on(eventName, () => {
				func();
			});
		});
	}

	/**
	 * Returns the base url for AdService-Scripts
	 * @returns {string}
	 */
	static getScriptBaseUrl () {
		let connectorVersion = AdServiceHelper.CONNECTOR_VERSION;
		const forcedVersion = Helper.getUrlParam('connectorVersion');

		if (forcedVersion) {
			if (forcedVersion === 'prev') {
				connectorVersion--;
				if (connectorVersion <= 0) {
					connectorVersion = 1;
				}
			} else if (forcedVersion === 'next') {
				connectorVersion++;
			} else {
				connectorVersion = parseInt(forcedVersion, 10) || connectorVersion;
			}
		}

		return '//dl.' + window.SiteInfo.brandShort + '.' + window.SiteInfo.tld + '/uim/connector/' + connectorVersion + '/';
	}
}

export { AdServiceHelper };
